import React, { useEffect, useState } from 'react'
import { BrowserRouter as Router, Routes, Route, useLocation, useNavigate } from 'react-router-dom'
import Lobby from './Lobby'
import Room from './Room'
import PokerHands from './PokerHands'
import FreeChips from './FreeChips'
import PrivacyPolicy from './PrivacyPolicy'
import TermsOfService from './TermsOfService'
import ResponsibleGaming from './ResponsibleGaming'
import ContactUs from './ContactUs'
import Login from './Login'
import Logout from './Logout'
import GetChips from './GetChips'
import Welcome from './Welcome'
import JoinTheRoom from './JoinTheRoom'
import Auth from './Auth'
import SiteMenu from './SiteMenu'
import UserStatisticsHandler from './UserStatisticsHandler'
import '../index.css'
import ReactGA from "react-ga4"

ReactGA.initialize("G-DDLP6EJFQH")


function App( socket ) {
  const s = socket.socket
  const [ user, setUser ] = useState( null )
  const [ dataForRoomEntry, setdataForRoomEntry ] = useState( null )
  const logout =()=>{ setUser( null ) }
  const [ isGetChipsShown, showGetChips ] = useState( false )
  const [ tableList, setTableList ] = useState( null )
  const [ roomData, setRoomData ] = useState( {} )
  const [ localMedia, setLocalMedia ] = useState( null )

  const [ soundEnabled, setSoundEnabled ] = useState( false )
  const [ localVideoIsChecked, setlocalVideoIsChecked ] = useState( false )
  const [ RTCmessages, setRTCmessages ] = useState([])
  const [ privateData, setPrivateData ] = useState({})
  const [ isAuthShown, showAuth ] = useState( false )
  const [ actionsAfterAuth, setActionsAfterAuth ] = useState( { linkPath : null, func : null, funcProp : null } )
  const userAgent = navigator.userAgent
  const [ width, setWidth ] = useState( window.innerWidth )
  const [ showSiteMenu, toggleSiteMenu ] = useState( false )
  const toggleSound = () => { setSoundEnabled(( prev ) => !prev )}
  const location = useLocation()

  function toggleGetChips(){ showGetChips( !isGetChipsShown )}
  function toggleAuth( arg ){ showAuth( arg ) }


  useEffect(()=>{
    window.addEventListener( 'resize', handleResize )
  },[ width ])


  useEffect(() => {
    if( localMedia ) {
      const audioTracks = localMedia.getAudioTracks()
      audioTracks.forEach(( track ) => {
        track.enabled = soundEnabled
    })}
  }, [ localMedia, soundEnabled ])


  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: location.pathname })
  }, [ location ])


  useEffect(() => {
    const handleRTCmessage = ( message ) => {
      setRTCmessages( prevMessages => [ ...prevMessages, message ])
    }
    s.on( 'user', ( user ) => {
      console.log( 'user' )
      console.log( user )
      setUser( user )
      setdataForRoomEntry( prevState => {
        return { ...prevState, user: user }
      })
    })
    s.on( 'tableChart', ( data ) => {
      setTableList( data )
    } )
    s.on( 'roomData', ( data ) => {
      if( data.room ) setRoomData( data.room )
    })
    s.on( 'visitorOrParticipantChanges', ( data )=>{
      handleVisitorOrParticipantChanges ( data )
    } )
    s.on('RTCmessage', ( data )=>{
      handleRTCmessage( data )
    } )
    s.on( 'visitor', ( data )=>{
      if( data.room ) setRoomData( data.room )
    })
    s.on( 'private', ( data )=>{
      setPrivateData(
        {
          cards : data.data.cards,
          evaluatedCards : data.data.evaluatedCards
        }
      )
    } )

    return () => {
      s.off( 'user' )
      s.off( 'tableChart' )
      s.off( 'roomData' )
      s.off( 'RTCmessage' )
      s.off( 'private' )
      s.off( 'visitorOrParticipantChanges' )
    }
  }, [ s, roomData ])


  function handleVisitorOrParticipantChanges(data) {
    let newRoom = JSON.parse(JSON.stringify(roomData)); // Deep copy of roomData

    // Update participants if they exist in the data
    if (data.data.participants) {
        newRoom.participants = data.data.participants;
    }

    // Update visitors if they exist in the data
    if (data.data.visitors) {
        newRoom.visitors = data.data.visitors;
    }

    // Update other room properties
    if (data.data.bankSum || data.data.bankSum === 0) newRoom.bankSum = data.data.bankSum;
    if (data.data.cards) newRoom.cards = data.data.cards;
    if (data.data.turn || data.data.turn == null) newRoom.turn = data.data.turn;
    if (data.data.roomAction) newRoom.roomAction = data.data.roomAction;
    if (data.data.gameIsActive || data.data.gameIsActive === false) newRoom.gameIsActive = data.data.gameIsActive;
    if (data.data.currentBet || data.data.currentBet === 0) newRoom.currentBet = data.data.currentBet;
    if (data.data.gameConfig) newRoom.gameConfig = data.data.gameConfig;

    // Update the roomData state
    setRoomData(newRoom);
}

  function removeRTCMessage( _id ) {
    setRTCmessages( prevMessages => prevMessages.filter( message => message.messageId !== _id ))
  }

  function clearRTCmessages (){
    setRTCmessages ([])
  }

  function clearDataAfterExitFromRoom(){
    if( user ) s.emit('toLobby', { userId: user._id })
    setPrivateData({})
    setRoomData({})
    
  }

  function handleResize() {
    setWidth( window.innerWidth )
  }

  
  return (
    <>

      <UserStatisticsHandler
        user={ user }
        steUsre={ setUser }
        socket={ socket }
      />
      <Welcome
        user={ user }
        socket={ socket }
        localVideoIsChecked={ localVideoIsChecked }
      />

      <Auth
        showAuth={ isAuthShown }
        toggleAuth={ toggleAuth }
        socket={ socket }
        user={ user }
        actionsAfterAuth={ actionsAfterAuth }
        setActionsAfterAuth={ setActionsAfterAuth }
      />
      <SiteMenu
        showSiteMenu = { showSiteMenu }
        toggleSiteMenu = { toggleSiteMenu }
        user={ user }
        logout={ logout }
        width={ width }
      />
      <GetChips
        toggleGetChips={ toggleGetChips }
        isGetChipsShown={ isGetChipsShown }
        socket={ socket }
        user={ user }
        toggleAuth={ toggleAuth }
      />
      <Routes>
        <Route path="/"
          element={ <Lobby
            user={ user }
            headerContext='lobby'
            toggleGetChips={ toggleGetChips }
            socket={ socket }
            tableList={ tableList }
            setdataForRoomEntry={ setdataForRoomEntry }
            toggleAuth={ toggleAuth }
            setActionsAfterAuth={ setActionsAfterAuth }
            userAgent={ userAgent }
            width={ width }
            showSiteMenu = { showSiteMenu }
            toggleSiteMenu = { toggleSiteMenu }
          />}/>
        <Route path="/room/"
          element={ <Room user={ user }
            localMedia={ localMedia }
            toggleSound={ toggleSound }
            soundEnabled={ soundEnabled }
            localVideoIsChecked={ localVideoIsChecked }
            setLocalMedia={ setLocalMedia }
            setlocalVideoIsChecked={ setlocalVideoIsChecked }
            toggleGetChips={ toggleGetChips }
            dataForRoomEntry={ dataForRoomEntry }
            setdataForRoomEntry={ setdataForRoomEntry }
            socket={ socket }
            roomData={ roomData }
            RTCmessage={ RTCmessages }
            clearRTCmessages={ clearRTCmessages }
            privateData={ privateData }
            clearDataAfterExitFromRoom={ clearDataAfterExitFromRoom }
            removeRTCMessage={ removeRTCMessage }
            toggleAuth={ toggleAuth }
            width={ width }
          />}/>
          <Route path="/join_room/:room_id"
            element={
              <JoinTheRoom
                dataForRoomEntry={ dataForRoomEntry }
                actionsAfterAuth={ actionsAfterAuth }
                setActionsAfterAuth={ setActionsAfterAuth }
                setdataForRoomEntry={ setdataForRoomEntry }
                width={ width }
                toggleAuth={ toggleAuth }
                socket={ socket }
                tableList={ tableList }/>
            } />
        <Route path="/pokerhands"
          element={ <PokerHands
            width={ width }
            user={ user }
            showSiteMenu = { showSiteMenu }
            toggleSiteMenu = { toggleSiteMenu }
          />}/>
        <Route path="/freechips"
          element={ <FreeChips
            width={ width }
            user={ user }
            showSiteMenu = { showSiteMenu }
            toggleSiteMenu = { toggleSiteMenu }
          />}/>
        <Route path="/privacypolicy"
          element={ <PrivacyPolicy
            width={ width }
            user={ user }
            showSiteMenu = { showSiteMenu }
            toggleSiteMenu = { toggleSiteMenu }
          />}/>
        <Route path="/termsofservice"
          element={ <TermsOfService
            width={ width }
            user={ user }
            showSiteMenu = { showSiteMenu }
            toggleSiteMenu = { toggleSiteMenu }
          />}/>
          <Route path="/responsiblegaming"
          element={ <ResponsibleGaming
            width={ width }
            user={ user }
            showSiteMenu = { showSiteMenu }
            toggleSiteMenu = { toggleSiteMenu }
          />}/>
        <Route path="/contactus"
          element={ <ContactUs
            width={ width }
            user={ user }
            socket={ socket }
            showSiteMenu = { showSiteMenu }
            toggleSiteMenu = { toggleSiteMenu }
          />}/>
        <Route path="/login"
          element={ <Login
            user={ user }
            socket={ socket }
            dataForRoomEntry={ dataForRoomEntry }
            setdataForRoomEntry={ setdataForRoomEntry }
            width={ width }
          />}/>
        <Route path="/logout"
          element={ <Logout
            logout={ logout }
            width={ width }
          />}/>
      </Routes>
    </>
  )
}

export default App